export default __webpack_public_path__ + "static/media/ocean-label.88f6971d.png";